/**
 * Welle 120 — Text-Bausteine (Thema „Rechnung" im Textsystem, gepflegt auch unter Schreiben › Themen):
 * „＋ Baustein" hängt einen gespeicherten Text an (mehrere nacheinander möglich), „als Baustein speichern"
 * legt den aktuellen Text als neuen Baustein an.
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { API_BASE } from "../../api/config";
import { API, json, ohneAnrede } from "./hilfen";
import Ico from "./Ico";

const SCHREIBEN_API = `${API_BASE}/mietverwaltung/api/schreiben`;

export function useBausteine() {
  const [daten, setDaten] = useState({ thema_id: null, bausteine: [] });
  const laden = useCallback(() => {
    fetch(`${API}/bausteine`).then(json).then(setDaten).catch(() => {});
  }, []);
  useEffect(() => { laden(); }, [laden]);
  return [daten, laden];
}

export default function BausteinWahl({ bausteine, onEinfuegen, aktuellerText = "", onGespeichert, nurEinfuegen = false,
  nurSpeichern = false }) {
  const [offen, setOffen] = useState(false);
  // kein window.prompt/alert: im Desktop-Browser (Electron) nicht erlaubt → Name inline abfragen
  const [titel, setTitel] = useState(null);         // null = Eingabe zu, sonst Name des neuen Bausteins
  const [meldung, setMeldung] = useState("");
  const box = useRef(null);
  useEffect(() => {
    const zu = (e) => { if (box.current && !box.current.contains(e.target)) setOffen(false); };
    document.addEventListener("mousedown", zu);
    return () => document.removeEventListener("mousedown", zu);
  }, []);

  const fragen = () => {
    const text = ohneAnrede(aktuellerText);
    if (!text) { setMeldung("Erst einen Text schreiben, dann als Baustein speichern."); return; }
    setMeldung(""); setTitel(text.split("\n")[0].slice(0, 50));
  };
  const speichern = async () => {
    const text = ohneAnrede(aktuellerText);                // Bausteine ohne Anrede (die kommt aus dem eigenen Feld)
    if (!titel || !titel.trim()) { setMeldung("Bitte einen Namen eintragen."); return; }
    try {
      await json(await fetch(`${SCHREIBEN_API}/bausteine`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ thema_id: bausteine.thema_id, titel: titel.trim(), text }) }));
      setMeldung(`Baustein „${titel.trim()}“ gespeichert.`); setTitel(null);
      onGespeichert && onGespeichert();
    } catch (e) { setMeldung(`Speichern fehlgeschlagen: ${e.message || e}`); }
  };

  const liste = bausteine.bausteine || [];
  return (
    <span className="rg-baustein" ref={box}>
      {!nurSpeichern && <button type="button" className="mb-link" onClick={() => setOffen((x) => !x)}><Ico n="plus" /> Baustein</button>}
      {!nurEinfuegen && titel === null && <button type="button" className="mb-link" onClick={fragen}>als Baustein speichern</button>}
      {titel !== null && (
        <span className="rg-baustein-name">
          <input className="mb-input" value={titel} autoFocus placeholder="Name des Bausteins, z. B. Pachtvertrag Hinweis"
            onChange={(e) => setTitel(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); speichern(); } else if (e.key === "Escape") setTitel(null); }} />
          <button type="button" className="mb-btn primary" onClick={speichern}>Speichern</button>
          <button type="button" className="mb-link" onClick={() => setTitel(null)}>abbrechen</button>
        </span>
      )}
      {meldung && <span className="rg-klein" style={{ margin: 0 }}>{meldung}</span>}
      {offen && (
        <div className="rg-baustein-liste">
          {!liste.length && <div className="rg-such-leer">Noch keine Bausteine — Text schreiben und „als Baustein speichern“.</div>}
          {liste.map((b) => (
            <button type="button" key={b.id} className="rg-such-treffer" title={b.text}
              onMouseDown={(e) => { e.preventDefault(); onEinfuegen(ohneAnrede(b.text || "")); setOffen(false); }}>
              <b>{b.titel}</b><span className="rg-baustein-vorschau">{String(b.text || "").slice(0, 90)}</span>
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
